import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const purchaseOrderVoidAtom = createMutationAtomFactory(
  'trade.purchaseOrderVoid',
  (params: { id: string }) => ({
    tradePurchaseOrderVoid: {
      __args: {
        id: params.id,
      },
      id: true,
      status: true,
      documentNumber: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
